import * as z from 'zod';

import type {CommerceProductColor} from '@/sanity/schemas/types';

export const productColorConfigurationSchema = z.string();

export type ProductColorConfiguration = z.infer<typeof productColorConfigurationSchema>;

export function getDefaultProductColorConfiguration(
	_colors: CommerceProductColor[],
): ProductColorConfiguration | null {
	return null;
}

export function productColorConfigurationFromFormData(
	options: CommerceProductColor[],
	namePrefix: string,
	formData: FormData,
): ProductColorConfiguration | null {
	let config: ProductColorConfiguration | null = null;

	const colorId = formData.get(`${namePrefix}`);
	for (const option of options) {
		if (option._id === colorId) {
			config = option._id;
			break;
		}
	}

	return config;
}
